import { IImageStyle } from "../../../../../../../documaker/domain/format/objects";
import { IImageAreaObject } from "../../../../../../domain/editableFormat/objects";
import { IImageAreaObjectBean } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class ImageStyleTranslator {
  from(bean: IImageAreaObjectBean): IImageStyle {
    return {
      angle: bean["@rotate-angle"] ? this.integer.from(bean["@rotate-angle"]) : 0,
    };
  }

  to(object: IImageAreaObject) {
    return {
      rotateAngle: (object.imageStyle.angle !== 0) ? this.integer.to(object.imageStyle.angle) : undefined,
    };
  }
 
  private readonly integer = new IntegerTranslator();
}
